import { useMemo } from 'react';
import useTypes from './useTypes';
import { Option } from '@/components/inputs/AutocompleteInput';
import { TypeApi } from '../models';

interface UseTypesOptionsProps {
  search?: string;
  minLength?: number;
  page?: number;
  pageSize?: number;
}

const useTypesOptions = ({
  search,
  minLength = 3,
  page = 1,
  pageSize = 5,
}: UseTypesOptionsProps = {}) => {
  const shouldSearch = search && search.length >= minLength;

  const { types, isLoading, error } = useTypes({
    search: shouldSearch ? search : '',
    page,
    pageSize: shouldSearch ? pageSize : 5,
  });

  const typeOptions: Option[] = useMemo(
    () =>
      types.map((type: TypeApi) => ({
        label: type.name,
        data: type.id,
      })),
    [types]
  );

  return {
    types,
    typeOptions,
    isLoading,
    error,
  };
};

export default useTypesOptions;
